import { Button } from '@/ui-kit'
import { ArrowLeft, RotateCcw } from 'lucide-react'

export const ErrorStep = ({
  error,
  onBack,
  findAndJoin
}: {
  error: string
  onBack: () => void
  findAndJoin: () => void
}) => {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <p className="text-destructive text-sm">{error}</p>
        <div className="flex gap-3">
          <Button variant="bordered" onClick={onBack}>
            <ArrowLeft className="size-4" />
            Back
          </Button>
          <Button onClick={() => findAndJoin()}>
            <RotateCcw className="size-4" />
            Retry
          </Button>
        </div>
      </div>
    </div>
  )
}
